import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Halaman Tidak Ditemukan | Toko Bangunan NJA Bajawa"
        description="Halaman yang Anda cari tidak ditemukan. Kembali ke beranda Toko Bangunan Nuansa Jaya Abadi di Bajawa."
        path="/404"
      />
      <section className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6">
        <p className="text-6xl font-extrabold text-brand">404</p>
        <h1 className="mt-4 text-2xl font-bold text-navy sm:text-3xl">
          Halaman tidak ditemukan
        </h1>
        <p className="mt-4 text-base text-slate-600">
          Maaf, halaman yang Anda cari tidak tersedia atau sudah dipindahkan.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-navy-light"
        >
          <Home className="h-4 w-4" aria-hidden="true" />
          Kembali ke Beranda
        </Link>
      </section>
    </>
  );
}
